export default __webpack_public_path__ + "static/media/1_logo.bc11a5ba.png";